/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EventManagementListEventForSelectRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: EventManagementListEventForSelectRequest.direction | null;
    title?: string | null;
    status?: string | null;
};

export namespace EventManagementListEventForSelectRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

